import { render, staticRenderFns } from "./ImageAnnotationEditor.vue?vue&type=template&id=7dcc662a&scoped=true&"
import script from "./ImageAnnotationEditor.vue?vue&type=script&lang=js&"
export * from "./ImageAnnotationEditor.vue?vue&type=script&lang=js&"
import style0 from "./ImageAnnotationEditor.vue?vue&type=style&index=0&id=7dcc662a&prod&scoped=true&lang=css&"
import style1 from "./ImageAnnotationEditor.vue?vue&type=style&index=1&id=7dcc662a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcc662a",
  null
  
)

export default component.exports